export default {
  error_occurred_when_loading_data: 'Error occurred when loading data',
  error_occurred_somewhere: 'An error occurred somewhere',
  logged_successfully: 'Přihlášení proběhlo úspešně',
  bad_credentials: 'Wrong combination of username and password.',
  me_loading_error: 'Error occured when loading your account',
  me_loading: 'Loading your account data',
  logged_out_successfully: 'Logged out successfully',
  added_to_my_selection_successfully: 'Successfully added into your selection',
  removed_from_my_selection_successfully:
    'Successfully removed from your selection',
  pending_adding_to_my_selection: 'Adding to your selection is in progress',
  pending_remove_from_my_selection:
    'Removing from your selection is in progress',
  no_record_found: 'No record found',
  illustration_not_found: 'Illustration not found',
  you_were_logged_out: 'Your session expired, please log in again',
  copied: 'Copied',
  pending_view_change_in_my_selection:
    'Pending view change of record in Mirador',
  changed_view_in_my_selection_successfully:
    'View change of record in Mirador finished successfully',
  loading: 'Loading...',
}
